import axios from "axios"
import { appUrl } from "../../../../../utils/config"
import { USER_ASSOCIATION_LOADING,USER_ASSOCIATION_SUCCESS,
USER_ASSOCIATION_ERROR,FETCH_PURCHASE_ORDER , FETCH_PURCHASE_ORDER_FILTER, FETCH_PURCHASE_ORDER_LOADING, FETCH_PURCHASE_ORDER_NEW, FETCH_PURCHASE_ORDER_QUICK_SUMMARY, FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW, PURCHASE_ORDER_QUICK_SUMMARY_LOADING, PO_STATUS_LOADING, PO_STATUS_SUCCESS, PO_STATUS_ERROR, FETCH_SL_FROM_PO_DASHBOARD_LOADING, FETCH_SL_FROM_PO_DASHBOARD_SUCCESS, FETCH_SL_FROM_PO_DASHBOARD_ERROR, CLEAR_SL_FROM_PO_DASHBOARD} from "../types"
import { fetchAllDashboardFilters, extractDashboardFilters } from "../../utils/filterUtils";

// let purchaseOrderSource;
export const fetchPurchaseOrders = (data) => (dispatch) => {
  // if (purchaseOrderSource !== undefined) {
  //   purchaseOrderSource.cancel('Request cancelled');
  // }
 
  // const CancelToken = axios.CancelToken;
  // purchaseOrderSource = CancelToken.source();
  dispatch({
    type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
    payload: true,
  });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPurchaseOrders`,
        data
        // ,{
        //   cancelToken: purchaseOrderSource.token,
        // }
      )
      .then((res) => {
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: false,
        });
        if (res.status === 200) {
          dispatch({
            type: FETCH_PURCHASE_ORDER,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_PURCHASE_ORDER_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_PURCHASE_ORDER,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_PURCHASE_ORDER_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_PURCHASE_ORDER,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
  
      
  let data1 = {
    ...data,
    scheduleAgreementStatusID: 0
  }
      axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOQuickSummary`,
        data1
      )
      .then((res) => {
        dispatch({
          type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
          payload: false,
        });
        if (res.status === 200) {
          dispatch({
            type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
};

// export const fetchPurchaseOrdersNew = (data, type) => (dispatch) => {
//   // if (purchaseOrderSource !== undefined) {
//   //   purchaseOrderSource.cancel('Request cancelled');
//   // }

//   // const CancelToken = axios.CancelToken;
//   // purchaseOrderSource = CancelToken.source();
//     axios
//       .post(
//         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPurchaseOrdersNew`,
//         data
//         // ,{
//         //   cancelToken: purchaseOrderSource.token,
//         // }
//       )
//       .then((res) => {
//         dispatch({
//           type: FETCH_PURCHASE_ORDER_LOADING,
//           payload: false,
//         });
//         if (res.status === 200) {
//           dispatch({
//             type: FETCH_PURCHASE_ORDER_NEW,
//             payload: res.data,
//           });
//         }
//       })
//       .catch((err) => {
//         if (err?.response?.status === 404) {
//           dispatch({
//             type: FETCH_PURCHASE_ORDER_LOADING,
//             payload: false,
//           });
//           dispatch({
//             type: FETCH_PURCHASE_ORDER_NEW,
//             payload: err.response.data,
//           });
//         } else {
//           dispatch({
//             type: FETCH_PURCHASE_ORDER_LOADING,
//             payload: false,
//           });
//           dispatch({
//             type: FETCH_PURCHASE_ORDER_NEW,
//             payload: {
//               status: false,
//               errorDescription:
//                 'Something went wrong. Please contact Schrocken Support.',
//             },
//           });
//         }
//       });
  
      
//       if (type === 'updatedPONegotiation' || type === undefined) {
//         dispatch({
//           type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//           payload: true,
//         });

//         let data1 = {
//           ...data,
//           scheduleLineStatusID: 0
//         }
//             axios
//             .post(
//               `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOQuickSummaryNew`,
//               data1
//             )
//             .then((res) => {
//               dispatch({
//                 type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//                 payload: false,
//               });
//               if (res.status === 200) {
//                 dispatch({
//                   type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
//                   payload: res.data,
//                 });
//               }
//             })
//             .catch((err) => {
//               if (err?.response?.status === 404) {
//                 dispatch({
//                   type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//                   payload: false,
//                 });
//                 dispatch({
//                   type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
//                   payload: err.response.data,
//                 });
//               } else {
//                 dispatch({
//                   type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//                   payload: false,
//                 });
//                 dispatch({
//                   type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
//                   payload: {
//                     status: false,
//                     errorDescription:
//                       'Something went wrong. Please contact Schrocken Support.',
//                   },
//                 });
//               }
//             });
//   }
  
  
// };



// OLD CODE - Sequential API calls (kept for reference)
// export const fetchPurchaseOrdersNew = (data, type) => async (dispatch) => {
//   // Extract cancelToken from data if provided, otherwise create a new one
//   const { cancelToken, ...requestData } = data;
//   const CancelToken = axios.CancelToken;
//   const source = cancelToken ? { token: cancelToken } : CancelToken.source();

//   try {
//     // First API call: fetchPurchaseOrdersNew
//     const response = await axios.post(
//       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPurchaseOrdersNew`,
//       requestData,
//       { cancelToken: source.token }
//     );

//     dispatch({
//       type: FETCH_PURCHASE_ORDER_LOADING,
//       payload: false,
//     });

//     if (response.status === 200) {
//       dispatch({
//         type: FETCH_PURCHASE_ORDER_NEW,
//         payload: response.data,
//       });
//     }

//     // Second API call: fetchPOQuickSummaryNew (if applicable)
//     if (type === 'updatedPONegotiation' || type === 'withQuickSummary' || type === undefined) {
//       dispatch({
//         type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//         payload: true,
//       });

//       const data1 = {
//         ...requestData,
//         scheduleLineStatusID: 0,
//       };

//       const summaryResponse = await axios.post(
//         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOQuickSummaryNew`,
//         data1,
//         { cancelToken: source.token }
//       );

//       dispatch({
//         type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//         payload: false,
//       });

//       if (summaryResponse.status === 200) {
//         dispatch({
//           type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
//           payload: summaryResponse.data,
//         });
//       }
//     }

//     return { status: true, data: response.data }; // Return a Promise with the main response
//   } catch (err) {
//     dispatch({
//       type: FETCH_PURCHASE_ORDER_LOADING,
//       payload: false,
//     });

//     if (axios.isCancel(err)) {
//       console.log('Request cancelled:', err.message);
//       return { status: false, cancelled: true };
//     }

//     if (err?.response?.status === 404) {
//       dispatch({
//         type: FETCH_PURCHASE_ORDER_NEW,
//         payload: err.response.data,
//       });
//     } else {
//       dispatch({
//         type: FETCH_PURCHASE_ORDER_NEW,
//         payload: {
//           status: false,
//           errorDescription: 'Something went wrong. Please contact Schrocken Support.',
//         },
//       });
//     }

//     
//     if (type === 'updatedPONegotiation' || type === 'withQuickSummary' || type === undefined) {
//       dispatch({
//         type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
//         payload: false,
//       });

//       if (err?.response?.status === 404) {
//         dispatch({
//           type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
//           payload: err.response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
//           payload: {
//             status: false,
//             errorDescription: 'Something went wrong. Please contact Schrocken Support.',
//           },
//         });
//       }
//     }

//     throw err; // Re-throw the error to allow .catch() in the caller
//   }
// };

//Sequential API calls
export const fetchPurchaseOrdersNew = (data, type) => async (dispatch) => {
  // Extract cancelToken from data if provided, otherwise create a new one
  const { cancelToken, ...requestData } = data;
  const CancelToken = axios.CancelToken;
  const source = cancelToken ? { token: cancelToken } : CancelToken.source();

  try {
    const withQuickSummary = type === 'updatedPONegotiation' || type === 'withQuickSummary' || type === undefined;
    const data1 = { ...requestData, scheduleLineStatusID: 0 };

    if (withQuickSummary) {
      dispatch({ type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING, payload: true });
    }

    const requests = [
      axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPurchaseOrdersNew`,
        requestData,
        { cancelToken: source.token }
      ),
    ];

    if (withQuickSummary) {
      requests.push(
        axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOQuickSummaryNew`,
          data1,
          { cancelToken: source.token }
        )
      );
    }

    const [response, summaryResponse] = await Promise.all(requests);

    dispatch({ type: FETCH_PURCHASE_ORDER_LOADING, payload: false });

    if (response.status === 200) {
      dispatch({ type: FETCH_PURCHASE_ORDER_NEW, payload: response.data });
    }

    if (withQuickSummary) {
      dispatch({ type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING, payload: false });
      if (summaryResponse && summaryResponse.status === 200) {
        dispatch({ type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW, payload: summaryResponse.data });
      }
    }

    return { status: true, data: response.data };
  } catch (err) {
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: false,
    });

    if (axios.isCancel(err)) {
      console.error('Request cancelled:', err.message);
      return { status: false, cancelled: true };
    }

    // Check if this is an error from the first API call (fetchPurchaseOrdersNew)
    // or the second API call (fetchPOQuickSummaryNew)
    const errorUrl = err?.config?.url || '';
    const isQuickSummaryError = errorUrl.includes('fetchPOQuickSummaryNew');

    // Only update FETCH_PURCHASE_ORDER_NEW if the error is from the main PO API
    if (!isQuickSummaryError) {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_PURCHASE_ORDER_NEW,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_PURCHASE_ORDER_NEW,
          payload: {
            status: false,
            errorDescription: 'Something went wrong. Please contact Schrocken Support.',
          },
        });
      }
    }

    
    if (type === 'updatedPONegotiation' || type === 'withQuickSummary' || type === undefined) {
      dispatch({
        type: PURCHASE_ORDER_QUICK_SUMMARY_LOADING,
        payload: false,
      });

      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW,
          payload: {
            status: false,
            errorDescription: 'Something went wrong. Please contact Schrocken Support.',
          },
        });
      }
    }

    throw err; // Re-throw the error to allow .catch() in the caller
  }
};

// Fetch Inactive Purchase Orders
export const fetchInActivePurchaseOrders = (data) => async (dispatch) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  try {
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    const response = await axios.post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchInActivePurchaseOrders`,
      data,
      { cancelToken: source.token }
    );

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: false,
    });

    if (response.status === 200) {
      dispatch({
        type: FETCH_PURCHASE_ORDER_NEW,
        payload: response.data,
      });
    }

    return { status: true, data: response.data };
  } catch (err) {
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: false,
    });

    if (axios.isCancel(err)) {
      console.log('Request cancelled:', err.message);
      return { status: false, cancelled: true };
    }

    if (err?.response?.status === 404) {
      dispatch({
        type: FETCH_PURCHASE_ORDER_NEW,
        payload: err.response.data,
      });
    } else {
      dispatch({
        type: FETCH_PURCHASE_ORDER_NEW,
        payload: {
          status: false,
          errorDescription: 'Something went wrong. Please contact Schrocken Support.',
        },
      });
    }

    throw err;
  }
};

export const fetchPurchaseOrdersForQuickSummary = (data) => async (dispatch) => {
  const { cancelToken, ...requestData } = data;
  const CancelToken = axios.CancelToken;
  const source = cancelToken ? { token: cancelToken } : CancelToken.source();

  try {
    const response = await axios.post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPurchaseOrdersNew`,
      requestData,
      { cancelToken: source.token }
    );

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: false,
    });

    if (response.status === 200) {
      dispatch({
        type: FETCH_PURCHASE_ORDER_NEW,
        payload: response.data,
      });
    }

    return { status: true, data: response.data };
  } catch (err) {
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: false,
    });

    if (axios.isCancel(err)) {
      console.error('Request cancelled:', err.message);
      return { status: false, cancelled: true };
    }

    if (err?.response?.status === 404) {
      dispatch({
        type: FETCH_PURCHASE_ORDER_NEW,
        payload: err.response.data,
      });
    } else {
      dispatch({
        type: FETCH_PURCHASE_ORDER_NEW,
        payload: {
          status: false,
          errorDescription: 'Something went wrong. Please contact Schrocken Support.',
        },
      });
    }

    throw err;
  }
};

let PurchaseOrdersFiltersSource;
export const fetchPurchaseOrdersFilters = () => (dispatch) => {
  if (PurchaseOrdersFiltersSource !== undefined) {
    PurchaseOrdersFiltersSource.cancel('Request cancelled');
  }

  const CancelToken = axios.CancelToken;
  PurchaseOrdersFiltersSource = CancelToken.source();
  axios
      .get(
        `${appUrl}/user/getSavedFiltersandColumns`,
        {
          cancelToken: PurchaseOrdersFiltersSource.token,
        }
      )
    .then((res) => {
      if (res?.data?.status) {
        dispatch({
          type: FETCH_PURCHASE_ORDER_FILTER,
          payload: res?.data
          })
      } else {
        dispatch({
          type: FETCH_PURCHASE_ORDER_FILTER,
          payload: {status: false}
          })
      } 
      })
    .catch((err) => {
      console.error(err)
      dispatch({
        type: FETCH_PURCHASE_ORDER_FILTER,
        payload: {status: false}
        })
    });
};
  

let dashboardPurchaseOrdersFiltersSource;
/**
 * Fetch filters for the purchase order dashboard
 */
export const fetchPurchaseOrdersDashboardFilters = () => async (dispatch) => {
  // Cancel previous request if it exists
  if (dashboardPurchaseOrdersFiltersSource !== undefined) {
    dashboardPurchaseOrdersFiltersSource.cancel('Request cancelled');
  }

  // Create a new CancelToken
  const CancelToken = axios.CancelToken;
  dashboardPurchaseOrdersFiltersSource = CancelToken.source();
  
  try {
    // Use the unified API to fetch all filters with CancelToken
    const allFilters = await fetchAllDashboardFilters(dashboardPurchaseOrdersFiltersSource.token);
    
    // Extract the purchase order dashboard filters
    const purchaseOrderFilters = extractDashboardFilters(allFilters, 'poCollaborationDashboard');
    
    dispatch({
      type: FETCH_PURCHASE_ORDER_FILTER,
      payload: purchaseOrderFilters
    });
    
    return purchaseOrderFilters;
  } catch (err) {
    // Don't report canceled requests as errors
    if (axios.isCancel(err)) {
      return { status: false };
    }
    
    console.error("Error fetching purchase order filters:", err);
    dispatch({
      type: FETCH_PURCHASE_ORDER_FILTER,
      payload: { status: false }
    });
    return { status: false };
  };
};

export const fetchFGStatus = () => (dispatch) => {
  dispatch({ type: PO_STATUS_LOADING, payload: true });
  
  return axios
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFGStatuses/true`)
    .then((res) => {
      dispatch({ type: PO_STATUS_SUCCESS, payload: res.data });
      dispatch({ type: PO_STATUS_LOADING, payload: false });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: PO_STATUS_ERROR,
        error: err?.response?.data || "FG Status fetch failed"
      });
      dispatch({ type: PO_STATUS_LOADING, payload: false });
      throw err;
    });
};

export const fetchUserAssociation = (saasUserID) => (dispatch) => {
  dispatch({ type: USER_ASSOCIATION_LOADING, payload: true });
  
  return axios
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchUserAssociations/${saasUserID}`)
    .then((res) => {
      dispatch({ type: USER_ASSOCIATION_SUCCESS, payload: res.data });
      dispatch({ type: USER_ASSOCIATION_LOADING, payload: false });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: USER_ASSOCIATION_ERROR,
        error: err?.response?.data || "User association fetch failed"
      });
      dispatch({ type: USER_ASSOCIATION_LOADING, payload: false });
      throw err;
    });
};

/**
 * Fetch Schedule Line Details from PO Dashboard
 */
export const fetchSLFromPODashboard = (schrockenSLID) => (dispatch) => {
  dispatch({ type: FETCH_SL_FROM_PO_DASHBOARD_LOADING, payload: true });
  
  const requestBody = {
    schrockenSLID: schrockenSLID
  };
  
  return axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchSLFromPODashboard`,
      requestBody
    )
    .then((res) => {
      dispatch({ 
        type: FETCH_SL_FROM_PO_DASHBOARD_SUCCESS, 
        payload: {
          schrockenSLID,
          data: res.data
        }
      });
      dispatch({ type: FETCH_SL_FROM_PO_DASHBOARD_LOADING, payload: false });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: FETCH_SL_FROM_PO_DASHBOARD_ERROR,
        error: err?.response?.data || "Failed to fetch schedule line details"
      });
      dispatch({ type: FETCH_SL_FROM_PO_DASHBOARD_LOADING, payload: false });
      throw err;
    });
};

/**
 * Clear Schedule Line Details from PO Dashboard (props data)
 * @param {string|null} schrockenSLID - If provided, clears only that SL. If null/undefined, clears all.
 */
export const clearSLFromPODashboard = (schrockenSLID = null) => (dispatch) => {
  dispatch({
    type: CLEAR_SL_FROM_PO_DASHBOARD,
    payload: schrockenSLID
  });
};